/**
 * Where the api lives, as seen from the browser.
 *
 * Vite proxies `/api` to the FastAPI service in dev, in `vite preview` and in the
 * static preview servers the Playwright journeys use (see `vite.config.ts` and
 * `scripts/serve-staff.mjs`), so every app in this repo speaks to one relative
 * origin and never needs CORS.
 */
export const API_BASE = '/api';
